import React, {useState, useEffect} from 'react'
import AdminWrapper from "../../theme/wrappers/AdminWrapper";
import FormModal from "../../theme/modals/FormModal";
import validators from "../../../utils/forms/validators";
import {nullBooleanSelect} from "../../../utils/forms/preconfiguredInputs";
import Input from "../../theme/forms/Input";
import api from "../../../store/api";
import {addErrorAlert, addSuccessAlert} from "../../../store/calls/alertLoadingDispatch";

const createEditInputs = [

    {
        type: 'text',
        label: "Type",
        dataKey: "model_name",
        options: [
            {
                display: "Project",
                value: "ProjectLead"
            },
            {
                display: "Application",
                value: "ProjectApplication"
            },
            {
                display: "File",
                value: "UserFile"
            },
        ],
        ...validators.exists
    }

]

const WebhookCreationForm = () => {

    return (
        <FormModal>

        </FormModal>
    )
}



const WebhookConfigScreen = ({...props}) => {


    const [displayedData, setDisplayedData] = useState([])

    const pullWebhookConfigs = () => {

        return api.get('/event-hooks')
            .then((res) => {
                setDisplayedData(res.data)
            })
    }

    useEffect(() => {
        pullWebhookConfigs()
    }, [])

    const makeInputs = () => {

        return displayedData
            .map((tbill, idx) => (
                <Input
                    label={tbill.term + " year rate"}
                    type={"text"}
                    classNames={"is-medium mb-5"}
                    value={tbill.rate}
                    onChange={val => handleValueChange(idx, val)}
                    addOns={[
                        <button
                            className="button is-info"
                            onClick={() => this.updateRate(tbill.id, tbill.rate)}
                        >
                            Update
                        </button>
                    ]}
                />
            ))


    }

    const getInputTitle = (data) => {
        switch (data.model_name)  {
            case 'ProjectApplication':
                return `Applications (${data.event_type})`
            case 'ProjectLead':
                return `Projects (${data.event_type})`
            case 'UserFile':
                return `Files (${data.event_type})`

        }
    }


    const handleValueChange = (idx, val) => {
        setDisplayedData(
            displayedData.map((d,i) => i === idx ? {...d, url: val} : d )
        );
    }

    const updateWebhookValue = (idx) => {
        const updateData = displayedData[idx]
        api.patch(`/event-hooks/${updateData.id}/`, {url: updateData.url})
            .then(() => {
                addSuccessAlert("Webhook url updated")
            })
            .catch(() => {
                addErrorAlert("Webhook update failed.")
            })
    }


    return (
        <AdminWrapper>
            <div className={'section'}>
                <div className={'container is-fullhd mx-6'}>
                    <div className={'level mb-6'}>
                        <div className={'level-left'}>
                            <div className={'level-item'}>
                                <h2 className={'title is-2 is-info'}>Webhooks</h2>
                            </div>
                        </div>
                        <div className={'level-right'}>
                        </div>
                    </div>
                    <p className={'mb-4'}>Webhooks are dispatched every hour, one per event.
                    </p>
                    <p><b>Projects</b> are address inquiries to which a user has at least assigned a dollar value.</p>
                    <p><b>Applications</b> are dispatched when a user has hit "Apply" and begun filling out the fields past the "Basic Information" (Name, contact info, role) section.</p>
                    <p><b>Files</b> are application-required documents that a user has uploaded..</p>


                    {displayedData.map((d,i) => (
                        <div className={'my-5'}>
                            <Input
                                label={getInputTitle(d)}
                                type={"text"}
                                classNames={"is-medium is-fullwidth m-5"}
                                controlClasses={"is-fullwidth"}
                                value={d.url}
                                onChange={val => handleValueChange(i, val)}
                                addOns={[
                                    <button
                                        className="button is-info"
                                        onClick={() => updateWebhookValue(i)}
                                    >
                                        Update
                                    </button>
                                ]}
                            />
                        </div>
                    ))}


                </div>
            </div>
        </AdminWrapper>
    )
}


export default WebhookConfigScreen;

